import { createEntityFilterStore } from "./createEntityFilterStore";
import type { InvestmentFilterState } from "@/domain/types";

const initialFilters: InvestmentFilterState = {
  search: "",
  sort: { key: undefined, direction: null },
};

export const useInvestorInvestmentFiltersStore = createEntityFilterStore<InvestmentFilterState>(
  "InvestorInvestmentFiltersStore",
  initialFilters,
);
